<template>
    <div class="">
            <div class="row">
                <div class="col-6">
                    <label>Method</label>
                    <select class="form-select" v-model="page.method">
                        <option>GET</option>
                        <option>POST</option>
                        <option>PUT</option>
                        <option>DELETE</option>
                        <option>OPTION</option>
                        <option>PATCH</option>
                    </select>
                </div>
                <div class="col-6">
                    <label>URL</label>
                    <input type="text" class="form-control" placeholder="/dashboard" required="true" v-model="page.page">
                </div>
            </div>
            <div v-if="success" class="mt-2 mb-2">
                <ul class="list-group">
                    <li class="list-group-item"><input type="radio" name="isFrom" v-model="isForm" value="true"> Form</li>
                    <li class="list-group-item"><input type="radio" name="isFrom" v-model="isForm" value="false"> API</li>
                </ul>
            </div>
            <div class="card mt-4">
                <div class="card-body">
                    <bodyheader :body="page.body" :header="page.header" v-if="success" @callback="getCallback" :key="reload"></bodyheader>
                </div>
            </div>

            <div class="mt-4">
                <button type="submit" class="btn btn-info btn-fill float-right" @click.prevent="createPage">
                {{ title }}
                </button>
            </div>
    </div>

</template>
<script>
    import bodyheader from '../../Tools/bodyheader.vue'

    export default {
        props: {
            page_id: Number
        },
        components: {
            bodyheader
        },
        data() {
            return {
                success: false,
                isForm: true,
                title: 'Create',
                reload: Math.random(),
                page: {
                    method: 'GET',
                    page: '',
                    value: [],
                    body: [{'parameter': '','value':''}],
                    header:[{'parameter': '','value':''}]
                }
            }
        },
        watch: {
            isForm: function(evt) {
                if (!evt) {
                    this.body = {};
                }

                this.reload = Math.random();
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            cleanPage(str) {
                var newStr = str.charAt(0);
                if (newStr == "/") {
                    str = str.substring(1);
                }

                str = "/" + str;
                return str;
            },

            getCallback(val) {
                this.page.body = val.body;
                if (!this.isForm) {
                   this.page.body = [{"parameter":"body", "value": JSON.stringify(val.body)}];
                }

                this.page.header = val.header;
            },

            createPage() {
                const me = this;
                me.page.page = me.cleanPage(me.page.page);
                var method = 'post';
                var host = this.$server + 'organisation/'+ me.$route.params.org_id + '/project/' + me.$route.params.prod_id + '/pages';

                if (this.page_id != 0) {
                    method = 'put';
                    host = this.$server + 'organisation/'+ me.$route.params.org_id + '/project/' + me.$route.params.prod_id + '/pages/' + this.page_id;
                }

                this.$axios({ method, url: host, data: this.page })
                    .then(res => {
                        var r = res.data;
                        if (r.success) {
                            me.$swal({
                              title: r.message
                            });

                        }
                    });
                this.$emit("callback", true);
            },
            init() {
                const me = this;
                if (this.page_id != 0) {
                    this.title = 'Edit';
                    this.$axios.get(this.$server + 'organisation/' + me.$route.params.org_id + '/project/' + me.$route.params.prod_id + '/pages/' + this.page_id)
                        .then(res => {
                            var r = res.data;
                            if (r.success) {
                                me.success = true;
                                me.page = r.data[0];
                                me.page.body = r.body;
                                me.page.header = r.header;
                            }
                        })
                        .catch(function(error) {
                            if (error.response.status == 401) {
                                me.$router.push({
                                    path: "/"
                                });
                            }
                        });
                } else {
                    this.success = true;
                }

                this.$emit("callback", this.title);
            }
        }
    }
</script>
